<div [class]="containerClass">
    <label for="startingTime" class="form-label" [class]="labelClass">{{labelText}}</label>
    <select id="startingTime" [(ngModel)]="selection" [class]="selectClass"
        [disabled]="dropdownDisabled!">
        <option *ngFor="let dropdownValue of dropdownValues" [ngValue]="dropdownValue?.minutes">{{dropdownValue.label}}</option>
    </select>
</div>
